import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_robobolsa.png",
      alt: "Estratégias Robô Bolsa",
    },
    title: "Opere com a Robô Bolsa",

    // String ou array de strings
    text: [
      "Desde 2018 oferecendo os melhores robôs para a B3, nossos robôs operaram de foram consistente por muitos anos trazendo maior rentabilidade e segurança para nossos clientes, sejam eles conservadores ou arrojados, temos as melhores opções para rentabilizar seus investimentos com praticidade.",
    ],
    testimonial: {
      text: "Atendimento excelente, rentabilidade muito acesso de qualquer produto do mercado de operações automatizadas, robô bolsa fez a diferença em meus investimentos",
      author: {
        name: "Pitter Medeiros",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias da Robô Bolsa",
    heading:
      "Algoritmos avançados que reconhecem as mudanças do mercado para se auto adaptar as operações",
    subtitle:
      "Estratégias com alta rentabilidade desenvolvidas por trader com mais de 15 anos de experiência. Nós fizemos o trabalho duro de desenvolvimento para entregar o melhor para você em apenas alguns cliques.",
  },

  cta: {
    title: "Está pronto para mudar sua forma de operar no mercado financeiro?",
    subtitle: "Ative agora mesmo os robôs da Robô Bolsa.",
    buttonText: "Ativar Agora!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Robô Bolsa",
    col1: [
      "Robô Bolsa é uma empresa que desenvolve robôs para operar de forma automática na Bolsa de Valores. Nossos robôs são robustos e usados por centenas de investidores desde 2018.",
      "Desde 2007 o autor da estratégia Daniel Moreira investe e desenvolve robôs para o mercado financeiro e tornou sua estratégia disponível apenas em 2018, sendo utilizada hoje por centenas de clientes. ",
    ],
    col2: [
      "Nossos robôs são utilizados algoritmos avançados capaz de reconhecer os padrões do mercado para se auto adaptar as constantes mudanças e assim ter rentabilidade à longo prazo.",
      "Elimine a tensão de operar manualmente e tenha ganhos extraordinários. Participe deste grupo de investidores ganhadores!",
    ],
  },

  stats: {
    title: "Alguns números da Robô Bolsa",
    subtitle:
      "Desde 2018 oferecendo robôs automatizados para o mercado financeiro brasileiro.",
    data: [
      {
        value: "4 anos",
        description: "Desde 2018",
      },
      {
        value: "+450",
        description: "Clientes",
      },
      {
        value: "+150k",
        description: "Ordens executadas por mês",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Porque utilizar os robôs da Robô Bolsa?",
    // subtitle: "Veja quais as principais vantagens dos robôs da TraderBot.",
    data: [
      {
        icon: iconsSet.money_off,
        title: "7 Dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta",
      },
      {
        icon: iconsSet.settings,
        title: "100% Automatizado",
        description:
          "Nossa equipe realiza todas as configurações necessárias para o robô operar automaticamente.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Individual",
        description: "Temos um time de suporte para tirar todas suas dúvidas.",
      },
      {
        icon: iconsSet.tune,
        title: "Adaptabilidade",
        description:
          "Nossos robôs se adaptam a qualquer tipo de mercado, mesmo sendo volátil ou não, direcional ou lateral, o robô poderá ter alta rentabilidade.",
      },
      {
        icon: iconsSet.ads_click,
        title: "Simplicidade",
        description:
          "Ao ativar o robô você não se preocupa com mais nada, o robô fará todas operações automaticamente sem sua intervenção.",
      },
      {
        icon: iconsSet.lock_line,
        title: "Segurança",
        description:
          "Cada robô tem suas características de ganhos e perdas, você sabe exatamente o que pode acontecer diariamente em sua conta, recebendo relatório diário em seu e-mail pelo Ontick.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Investimento automatizado, consistente e mais rentável do que qualquer fundo de investimentos, recomendo!",
      author: "Roberto Heleno",
      job: "Consultor Empresarial",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Eu operava manualmente mas sem sucesso, com este robô tudo fica mais fácil. Parabéns Robô Bolsa!",
      author: "Pitter Medeiros",
      job: "Empresário",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
